var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Photo Uploader")]),_c('PhotoUploader',{attrs:{"update":_vm.photosUpdated,"accept":"image/png, image/jpeg, image/jpg, application/pdf"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }